import { render, staticRenderFns } from "./add-beta-job.vue?vue&type=template&id=a9bce0ee&scoped=true"
import script from "./add-beta-job.vue?vue&type=script&lang=js"
export * from "./add-beta-job.vue?vue&type=script&lang=js"
import style0 from "./add-beta-job.vue?vue&type=style&index=0&id=a9bce0ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bce0ee",
  null
  
)

export default component.exports